import { CircularProgress, Grid, Tooltip } from "@mui/material";
import Table from "components/Table";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import ReportingTextInput from "components/Reporting/ReportingTextInput/index";
import BudgetCapModal from "../budgetCapModal";
import TableValueEditor from "../tableValueEditor";
import {
  channelIds,
  ChannelImageMapper,
  getFilterOptionsURLByPlatform,
  getTableReportURLByPlatfrom,
} from "../utils";
import Filters, { FilterChips } from "components/Reporting/Filters";
import { useReportingFilters } from "hooks/useReportingFilters";
import { createSearchParams, Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import "./TableContainer.scss";
import BidPopover from "../BidPopover/BidPopover";
import { platformDesignationOptions, platformOptions } from "mock/filterOptions";
import { updatePlatform, updateSegmentList, updateSelectedSegments } from "store/slices/metaSearch/metaSearch";
import { enqueueSnackbar } from "notistack";
import {getUserToken} from "../../../utils/functions/userToken";
import { getSelectedSegments } from "utils/functions/getSelectedSegment";
import { updateGroupId, updateHotelId, updateLevel } from "store/slices/account/accountSlice";
import qs from 'query-string'

const TableContainer = ({
  hotelList = [],
  isChartCollapsed,
  setIsChartCollapsed,
  onEditClick,
  isAccountWritable,
  noBiddingOption= false,
}) => {
  const {pathname, search} = useLocation();
  const searchParams = qs.parse(search);
  const searchParamsRef = useRef(searchParams);
  searchParamsRef.current = searchParams;
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [openMonthlyBudgetCapModal, setOpenMonthlyBudgetCapModal] =
    useState(false);
  const [selectedBudgetRow, setSelectedBudgetRow] = useState();
  const [bidEditModal, setbidEditModal] = useState(false);
  const [columns, setColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isPaginationEnabled, setIsPaginationEnabled] = useState(false);
  const [isBulkEditEnabled,setIsBulkEditEnabled] = useState(false);
  const [isBulkEditStatusEnabled,setIsBulkEditStatusEnabled] = useState(false);
  const [isBulkEditBudgetEnabled,setIsBulkEditBudgetEnabled] = useState(false);
  const [isBulkAllEnabled,setIsBulkAllEnabled] = useState(false);
  const [allEntityIds,setAllEntityIds] = useState([]);
  const [bulkEditOptionsList,setBulkEditOptionsList] = useState([]);
  const [statusURL, setStatusURL] = useState("");
  const [budgetURL, setBudgetURL] = useState("");
  const [editBidBudgetCurrency, setEditBidBudgetCurrency] = useState("");
  const [editBidMinBudget, setEditBidMinBudget] = useState(0);
  const [paginationObject, setPaginationObject] = useState({});
  const [pageSize, setPageSize] = useState(15);
  const [pageIndex, setPageIndex] = useState(0);
  const [sortingState, setSortingState] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = getUserToken() || "";
  const {
    account_id = "",
  } = useSelector((state) => state?.account?.account || {});
  const {
    level = "",
    hotel_id = [],
    group_id = [],
  } = useSelector(state => state?.account)
  const { currentDateRange = {}, comparitionDateRange = {}, compareWith } = useSelector(
    (state) => state?.calender
  );
  const {
    segment_list,
    selected_segments,
    platform = [],
  } = useSelector((state) => state?.metaSearch);

  const effectiveSegments = useMemo(() => {
    const requiredSegments = getSelectedSegments(
      platform,
      level === "HOTEL" ? hotel_id : group_id,
      level
    ) || [];
    const validSegmentList = Array.isArray(segment_list)
      && requiredSegments[0]
      && segment_list.includes(requiredSegments[0]);

    return validSegmentList ? segment_list : (selected_segments || []);
  }, [platform, level, hotel_id, group_id, segment_list, selected_segments]);

  const filterOptionsUrl = getFilterOptionsURLByPlatform(platform);
  const metaChannelIds = useMemo(
    () => platform.length !== 1
      ? platform.map((item) => item?.channel_id || channelIds?.[item?.id]).filter(Boolean)
      : [],
    [platform]
  );
  const handleFiltersChange = useCallback(() => setPageIndex(0), []);
  const {
    filterColumnOptions,
    appliedFilters,
    appliedOperator,
    filterOpenTrigger,
    tableFilterParams,
    isFilterMetadataLoading,
    isFilteringSupported,
    applyFilters,
    clearFilters,
    removeFilter,
    openFilters,
    markFiltersApplied,
  } = useReportingFilters({
    filterOptionsUrl,
    token,
    accountId: account_id,
    level,
    hotelId: hotel_id,
    groupId: group_id,
    metaChannelIds,
    currentDateRange,
    segmentList: effectiveSegments,
    selectedColumns,
    onFiltersChange: handleFiltersChange,
  });


    const loadTableData = useCallback(async () => {
    const isTrueSegment = effectiveSegments;
    const params = {
      account_id,
      level,
      "segment_list[]": isTrueSegment,
      start_date: format(
        currentDateRange?.startDate || new Date(),
        "yyyy-MM-dd"
      ),
      end_date: format(currentDateRange?.endDate || new Date(), "yyyy-MM-dd"),
      ...(comparitionDateRange?.startDate ? {compare_start_date: 
         format(comparitionDateRange?.startDate, "yyyy-MM-dd")
        }: {}),
        ...(comparitionDateRange?.endDate ? {compare_end_date: 
          format(comparitionDateRange?.endDate, "yyyy-MM-dd")
         }: {}),
      ...(level === "HOTEL"
        ? { "hotel_id[]": hotel_id }
        : { "group_id[]": group_id }),
      page_number: pageIndex,
      number_of_rows: pageSize,
      "sort_asc[]": sortingState
        ?.filter((sort) => !sort?.desc)
        ?.map((s) => s?.id),
      "sort_desc[]": sortingState
        ?.filter((sort) => sort?.desc)
        ?.map((s) => s?.id),
        ...(platform?.length > 1 ?  {
            "meta_channel[]": platform?.map((p) => p?.channel_id || channelIds?.[p?.id]),
          }: {}),
        ...tableFilterParams,
    };
    if (account_id && level && hotelList?.every(h => String(h?.account_id)=== String(account_id)) && Array.isArray(isTrueSegment) && isTrueSegment.length > 0 && (level === "HOTEL" ? hotel_id?.length > 0 : group_id?.length > 0)) {
      setLoading(true);
      setTableData([]);
      await axios
        .post(
          `${getTableReportURLByPlatfrom(platform)}`, createSearchParams(
            params
          ),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const data = res?.data;
          setIsPaginationEnabled(data?.paginator_enabled);
          setIsBulkEditEnabled(data?.bulk_edit_enabled);
          setIsBulkEditStatusEnabled(data?.bulk_edit_status);
          setIsBulkEditBudgetEnabled(data?.bulk_edit_budget);
          setIsBulkAllEnabled(data?.is_all_bulk_enabled);
          setAllEntityIds(Object.values(data?.all_entity_id || {}) || []);
          setStatusURL(data?.bulk_edit_status_endpoint || "");
          setBudgetURL(data?.bulk_edit_budget_endpoint || "");
          setBulkEditOptionsList(data?.bulk_edit_status_list || []);
          setEditBidBudgetCurrency(data?.bulk_edit_budget_symbol || "");
          setEditBidMinBudget(data?.bulk_edit_budget_min_budget || 0);
          setPaginationObject(data);
          const sortedColumns = [
            ...data?.columns
              ?.filter(
                (col) => col?.type === "SEGMENT"
              )
              ?.map((c) => ({ ...c})),
              ...data?.columns
              ?.filter(
                (col) => col?.type === "GENERIC"
              )
              ?.map((c) => ({ ...c})),
            ...data?.columns?.filter(
              (col) => col?.type !== "METRICS" && col?.type !== "SEGMENT" && col?.type !== "GENERIC"
            ),
            ...data?.columns?.filter((col) => col?.type === "METRICS"),
          ];
          const mappedColumns = sortedColumns?.map((col, index) => {
            let renderCell = ({ row, cell }) => {
              let style = {};
              if (row.id === "0" && cell.column.id === "0") {
                style = {
                  ...style,
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: "600",
                };
              }
              return compareWith && col?.type !== "SEGMENT" ? (
                <Tooltip
                  title={`${
                    row?.original?.[
                      `${cell.column?.columnDef?.accessorKey}_compare`
                    ]
                  } ${
                    row?.original?.[
                      `${cell.column?.columnDef?.accessorKey}_compare_percent`
                    ]
                  }%`}
                >
                  <span style={style}>{cell.getValue()}</span>
                </Tooltip>
              ) : (
                <span style={style}>{cell.getValue()}</span>
              );
            };

            if (col.id === "budget_spent") {
              renderCell = ({ row, cell }) => {
                return (
                  <Tooltip
                    title={
                      <div className="remaining-budget-tooltip">
                        <span className="tooltip-label">Budget Remaining</span>
                        <span>{row?.original?.budget?.budget_symbol} {row?.original?.budget_remaining}</span>
                      </div>
                    }
                  >
                    <span
                      style={{
                        color: row?.original?.budget_alert ? "red" : "inherit",
                      }}
                    >
                      {cell.getValue()}
                    </span>
                  </Tooltip>
                );
              };
            }

            if(col?.id === "channel_code"){
              renderCell = ({row, cell}) => {
                return row?.id !== "0" ? <span className="clickable-element" style={{
                  cursor: "pointer", display: "flex", alignItems: "center"
                }} onClick={() => {
                  const selectedPlatform = [...platformOptions, ...platformDesignationOptions].find(p => p.channel_id === row?.original?.channel_code_id)
                  dispatch(updatePlatform([selectedPlatform]))
                  dispatch(updateSegmentList(getSelectedSegments([selectedPlatform], level === "HOTEL" ? hotel_id : group_id, level)))
                  dispatch(updateSelectedSegments(null))
                  navigate(`${pathname}?${createSearchParams({
                    ...searchParamsRef.current,
                    platform: selectedPlatform?.channel_id,
                    segments: getSelectedSegments([selectedPlatform], level === "HOTEL" ? hotel_id : group_id, level),
                  })}`)
                }}>{cell.getValue()}</span>: <span>{cell.getValue()}</span>
              }
            }

            if(col?.id === "idhotel"){
              renderCell = ({ row, cell }) => {
                let segment = ["CHANNEL"]
                if (platform?.length === 1) {
                  if (platform?.[0].id === "wego") {
                    segment = ["HOTEL"]
                  } else {
                    segment = ["MARKET"]
                  }
                }
                const params = {
                  ...searchParamsRef.current,
                  hotelid: row?.original?.idhotel_id,
                  segments: segment
                }

                delete params?.groupid
                return row?.id !== "0" ? (
                  <Link
                    to={`${pathname}?${createSearchParams(params)}`}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                    onClick={() => {
                      dispatch(updateLevel("HOTEL"))
                      dispatch(updateHotelId([Number(row?.original?.idhotel_id)]))
                      dispatch(updateGroupId([]))
                      if(platform?.length === 1){
                        if(platform?.[0].id === "wego"){
                          dispatch(updateSegmentList(["HOTELS"]))
                        } else {
                          dispatch(updateSegmentList(["MARKET"]))
                        }
                      } else {
                        dispatch(updateSegmentList(["CHANNEL"]))
                      }
                    }}
                  >
                    <span className="clickable-element">{cell.getValue()}</span>
                  </Link>
                ) : (
                  <span>
                    {cell.getValue()}
                  </span>
                );
              };
            }

            if(col?.id === "id_group"){
              renderCell = ({ row, cell }) => {
                const params = {
                  ...searchParamsRef.current,
                  groupid: row?.original?.id_group_id,
                }

                delete params?.hotelid
                return row?.id !== "0" ? (
                  <Link
                    to={`${pathname}?${createSearchParams(params)}`}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                    onClick={() => {
                      dispatch(updateLevel("GROUP"))
                      dispatch(updateHotelId([]))
                      dispatch(updateGroupId([row?.original?.id_group_id]))
                      dispatch(updateSegmentList(getSelectedSegments(platform, [row?.original?.id_group_id], level)))
                      dispatch(updateSelectedSegments(null))
                    }}
                  >
                    <span className="clickable-element">{cell.getValue()}</span>
                  </Link>
                ) : (
                  <span>
                    {cell.getValue()}
                  </span>
                );
              };
            }

            if (col?.type === "BUDGET") {
              renderCell = ({ row }) => {
                return (
                  <>
                    {row?.original?.budget?.budget_editable && (
                        <span key={row.id} style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                        <ReportingTextInput
                            numberUnit={""}
                            sx={{
                              width: "69px",
                              fontSize: "12px",
                              fontFamily: "Roboto",
                              textAlign: "right",
                              backgroundColor: row?.original?.budget?.budget_editable
                                  ? ""
                                  : "lightgray",
                              paddingRight: "1px",
                              display: "flex",
                            }}
                            value={row?.original?.budget?.budget_value}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedBudgetRow(row?.original);
                              setOpenMonthlyBudgetCapModal(true);
                            }}
                        />
                      </span>
                    )}
                  </>
                );
              };
            }

            if (col?.type  === "BID") {
              renderCell = ({ row, cell }) => {
                const updateBidData = row?.original?.[cell?.column?.columnDef?.accessorKey];
                //@TODO Arshad please refractor this for total row
                return row.id !== "0" && (
                  <BidPopover bid={updateBidData} onLoadTable={loadTableData} />
                );
              };
            }
            return {
              id: index.toString(),
              accessorKey: col.id,
              Header: <Tooltip title={col?.description}><span>{col?.label}</span></Tooltip>,
              header: col?.label,
              Cell: renderCell,
              isSelected: col?.is_visible !== undefined ? col?.is_visible : true,
              type: col?.type,
              isVisible: col?.is_visible !== undefined ? col?.is_visible : true,
            };
          });

          const formatRows = (row, id) => {
            const metricsRows = Object.keys(row?.metrics_list || {}).reduce(
              (acc, curr) => {
                return {
                  ...acc,
                  [curr]: row?.metrics_list?.[curr]?.value ?? "-",
                  [`${curr}_compare`]:row?.metrics_list?.[curr]?.compared_value,
                  [`${curr}_compare_percent`]: row?.metrics_list?.[curr]?.compare_percent
                };
              },
              {}
            );

            const segmentsRows = Object.keys(row?.segment_list || {}).reduce(
              (acc, curr) => {
                return {
                  ...acc,
                  [curr]: row?.segment_list?.[curr]?.label ?? "-",
                  [curr + "_id"]: row?.segment_list?.[curr]?.value ?? "-",
                  ...(Object.keys(row?.segment_list).includes("channel_code")
                    ? {
                        channel_code: ChannelImageMapper(
                          `${pathname}?${createSearchParams({
                            ...searchParamsRef.current,
                            platform:
                              row?.segment_list?.["channel_code"]?.value,
                            segments: getSelectedSegments(
                              [row?.segment_list?.["channel_code"]?.value],
                              level === "HOTEL" ? hotel_id : group_id,
                              level
                            ),
                          })}`
                        )?.[row?.segment_list?.["channel_code"]?.value],
                      }
                    : {}),
                };
              },
              {}
            );

            const bidRows = Object.keys(row || {}).filter(key => row[key]?.type === "BID").reduce((acc,curr) => {
              acc[curr] = row?.[curr] || {}
              return acc;
            },{})

            const infoRows = Object.keys(row?.info_list || {}).reduce((acc,curr) => {
              const infoObject = row?.info_list?.[curr];
              return {
                ...acc,
                [curr]: data?.[infoObject?.attribute]?.[infoObject?.value]?.[infoObject?.info_path]
              }
            }, {})

            return {
              id,
              ...segmentsRows,
              ...infoRows,
              ...metricsRows,
              ...bidRows,
              budget: row?.budget,
              budget_spent: row?.budget_spent?.budget_spent,
              budget_remaining: row?.budget_spent?.budget_remaining,
              budget_alert: row?.budget_spent?.put_alert_color,
              status: row?.status?.show_loader ? <span className="status-label"><CircularProgress size={16} /> {row?.status?.label}</span> : row?.status?.label,
              status_label: row?.status?.label,
              bulk_edit_budget: row?.bulk_edit_budget,
              bulk_edit_status: row?.bulk_edit_status,
              bulk_edit_enabled: row?.bulk_edit_enabled,
              budget_entity_id: row?.budget_entity_id,
              status_entity_id: row?.status_entity_id,
            };
          };

          const rowsToDisplay = data?.row_list?.map((row, ind) =>
            formatRows(row, ind + 1)
          );
          setColumns(mappedColumns);
          setLoading(false);
            setSelectedColumns(
              mappedColumns.filter((col) =>
                col?.type === "METRICS"
                  ? col?.isVisible
                  : col
              )
            );
          setTableData([
            {
              [mappedColumns?.[0]?.accessorKey]: "TOTAL",
              ...formatRows(data?.total_row, "0"),
            },
            ...rowsToDisplay,
          ]);
          markFiltersApplied();
        }).catch(err => {
          console.error(err);
          enqueueSnackbar({
            message: "An error occured",
            variant: "error"
          })
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(platform),
    token,
    account_id,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(currentDateRange),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(comparitionDateRange),
    level,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(sortingState),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(segment_list),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(selected_segments),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(tableFilterParams),
    pageSize,
    pageIndex,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(hotel_id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(group_id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(hotelList),
  ]);

  useEffect(() => {
    setPageIndex(0);
  }, [hotel_id, group_id, segment_list, selected_segments, platform, level])

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(platform),
    token,
    account_id,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(currentDateRange),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(comparitionDateRange),
    level,
    pageSize,
    pageIndex,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(sortingState),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(segment_list),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(selected_segments),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(tableFilterParams),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(hotel_id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(group_id),
    compareWith,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(hotelList),
  ]);

  //@TODO pour la taille de la table
  const getMaxHeight = () => {
    if (isChartCollapsed) {
      return isPaginationEnabled
          ? "calc(100vh - 215px)"
          : "calc(100vh - 182px)";
    } else {
      return isPaginationEnabled
          ? "calc(100vh - 443px )"
          : "505px";
    }
  };

  return (
    <>
      {bidEditModal && (
        <TableValueEditor
          open={bidEditModal}
          bid={selectedBudgetRow?.bid}
          onClose={() => setbidEditModal(false)}
        />
      )}
      <Grid sx={{ marginBlock: "10px", maxWidth: "100%", marginLeft: "4px" }}>
        <Table
          selectedPlatform={platform}
          page="metaSearch"
          isAccountWritable={isAccountWritable}
          rows={tableData}
          columns={columns}
          selectedColumns={selectedColumns}
          handleColumnSelectionChange={(columns) => {
            setSelectedColumns(columns);
          }}
          selectedSegments={effectiveSegments}
          filters={isFilteringSupported ? (
            <Filters
              columnOptions={filterColumnOptions}
              isLoading={isFilterMetadataLoading}
              onSave={applyFilters}
              appliedFilters={appliedFilters}
              appliedOperator={appliedOperator}
              onClear={clearFilters}
              openTrigger={filterOpenTrigger}
            />
          ) : null}
          filterChips={isFilteringSupported ? (
            <FilterChips
              appliedFilters={appliedFilters}
              appliedOperator={appliedOperator}
              columnOptions={filterColumnOptions}
              onClear={clearFilters}
              onRemoveFilter={removeFilter}
              onChipClick={openFilters}
            />
          ) : null}
          paginationData={paginationObject}
          isPaginationEnabled={isPaginationEnabled}
          isChartCollapsed={isChartCollapsed}
          setIsChartCollapsed={setIsChartCollapsed}
          maxHeight={getMaxHeight}
            onEditClick={() => {
            onEditClick();
          }}
          handlePagination={(pagination) => {
            setPageIndex(pagination?.pageIndex);
            setPageSize(pagination?.pageSize);
          }}
          initialPageSize={pageSize}
          initialPageIndex={pageIndex}
          noBiddingOption={noBiddingOption}
          handleSorting={(sorting) => {
            setSortingState(sorting);
          }}
          isLoading={loading}
          enableRowSelection={isBulkEditEnabled || false}
          isBulkEditStatusEnabled={isBulkEditStatusEnabled || false}
          isBulkEditBudgetEnabled={isBulkEditBudgetEnabled || false}
          isBulkAllEnabled={isBulkAllEnabled || false}
          allEntityIds={allEntityIds || []}
          statusURL={statusURL}
          budgetURL={budgetURL}
          bulkEditOptionsList={bulkEditOptionsList}
          editBidBudgetCurrency={editBidBudgetCurrency}
          editBidMinBudget={editBidMinBudget}
          loadTableData={loadTableData}
        />
      </Grid>
      {openMonthlyBudgetCapModal && (
        <BudgetCapModal
          open={openMonthlyBudgetCapModal}
          budget={selectedBudgetRow?.budget}
          onClose={() => {
            setSelectedBudgetRow(null);
            setOpenMonthlyBudgetCapModal(false);
          }}
          onLoadTable={loadTableData}
        />
      )}
    </>
  );
};

export default TableContainer;
